// extracted by mini-css-extract-plugin
export default {"user-group-icon":"styles_user-group-icon__cvL1u","user-group-icon__icon":"styles_user-group-icon__icon__8w4Tx"};